.container > :not(:last-child) {
    margin-bottom: 32px;
}
